/* global window */
import objectFitImages from 'object-fit-images';
import $ from 'jquery';
import 'parsleyjs';
import 'parsleyjs/dist/i18n/pl';
import PerfectScrollbar from 'perfect-scrollbar';
import domRouter from './modules/domRouter';

domRouter
  .add('all', () => {
    // Run object-fit-images polyfill
    objectFitImages();

    $('.js--form')
      .parsley({
        errorClass: 'form__input--invalid',
        successClass: 'form__input--success',
        errorsWrapper: '<div class="form__validation-wrap form__validation-wrap--active"></div>',
        errorTemplate: '<p class="form__validation-message"></p>',
      });
  })
  .add('mw-find-company', () => {
    const ps = new PerfectScrollbar('#js--scrollbar', { // TODO: the config is not required
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20,
    });

    $(window)
      .on('resize', () => {
        ps.update();
      });
  })
  .run();
